import api from "../api";
import { JEWELLERY_API_ENDPOINTS } from "../../constants/jewellery.constant";

const reportService = {
  // Get daily collections
  getDailyCollections: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.DAILY_COLLECTIONS, {
      params,
    });
    return response.data;
  },

  // Get pending verifications
  getPendingVerifications: async (params = {}) => {
    const response = await api.get(
      JEWELLERY_API_ENDPOINTS.PENDING_VERIFICATIONS,
      { params }
    );
    return response.data;
  },

  // Get overdues
  getOverdues: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.OVERDUES, {
      params,
    });
    return response.data;
  },

  // Get maturities
  getMaturities: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.MATURITIES, {
      params,
    });
    return response.data;
  },

  // Get redemptions report
  getRedemptionsReport: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.REDEMPTIONS_REPORT, {
      params,
    });
    return response.data;
  },

  // Get dashboard stats
  getDashboardStats: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.DASHBOARD_STATS, {
      params,
    });
    return response.data;
  },

  // Export ledger
  exportLedger: async (params = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.EXPORT_LEDGER, {
      params,
      responseType: "blob", // For file download
    });
    return response.data;
  },
};

export default reportService;
